import React from "react";
import Money from "shared/components/Money";
import { getBaseUnit } from "./getBaseUnit";
import { calculateBasePrice } from "./calculateBasePrice";

const displayUnit = baseUnit => {
  switch (baseUnit) {
    case "Gramm":
      return "g";
    case "Kilogramm":
      return "kg";
    case "Liter":
      return "l";
    case "Mililiter":
      return "ml";
    default:
      return baseUnit;
  }
};

export default function BasePrice(props) {
  const { product } = props;

  const baseUnit = getBaseUnit(product.salesUnitType);
  const basePrice = calculateBasePrice(
    product.salesUnitQuantity,
    product.rrp,
    baseUnit,
  );
  let baseType;
  if (!basePrice) {
    return <span>Nicht verfügbar</span>;
  }

  if (baseUnit === "Gramm" || baseUnit === "Mililiter") {
    baseType = `100${displayUnit(baseUnit)}`;
  } else {
    baseType = `1${displayUnit(baseUnit)}`;
  }

  return (
    <span>
      <Money value={basePrice} /> / {baseType}
    </span>
  );
}
